import { Component, Input } from "@angular/core"

@Component({
	selector: "app-gmap-button",
	templateUrl: "./gmap-button.component.html",
	styles: ["./gmap-button.component.scss"]
})
export class GMapButtonComponent {
	@Input() options: any
}
